export default __webpack_public_path__ + "static/media/notePadLBIcon.13ccf407.svg";